import styled from "styled-components/macro";
import { PrimaryButton, SecondaryButton } from "@loanbossinc/component-library";

export const StyledSecondaryButton = styled(SecondaryButton)`
  && {
    background: #ffffff;
    color: #005aa9;
    border: 1px solid #005aa9;
    box-sizing: border-box;
    border-radius: 4px;
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    margin-left: 1em;
    &:disabled {
      background: #c4c4c4 !important;
    }
    &:hover {
      background: #004d91;
    }
  }
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2em;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  padding: 1em 2em;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LBRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1em 2em;
  border-bottom: 1px solid #dadce0;
  box-sizing: border-box;
`;

export const LBRowInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const LBRowDebtString = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 0.7em;
  text-transform: uppercase;
`;

export const LBRowDerivedString = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #5f6368;
`;

export const NameDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 1.5em;
`;

export const NameWrapper = styled.div`
  && {
    font-family: Work Sans;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const UploadDate = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
`;

export const WideStyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    font-size: 13px;
    margin-left: 1em;
    white-space: nowrap;
    width: 170px !important;

    &:hover {
      background: #005aa9 !important;
    }
  }
`;

export const InfoWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #dadce0;
    padding: 0.5em 1em;
    box-sizing: border-box;
  }
`;

export const AsOfDateWrapper = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 2em;
`;

export const SelectDiv = styled.div`
  width: 12%;
`;
